import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IExternalUser } from '@core/model';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-user-details',
    templateUrl: './user-details.component.html',
    styleUrls: ['./user-details.component.scss'],
    standalone: false
})
export class UserDetailsComponent implements OnInit, OnDestroy {
  userId!: string;
  userData!: IExternalUser;
  private subs: Subscription = new Subscription();
  accountTypeNew!: string;
  userAccountInformationChanged = 0;
  disableRadioButtons : boolean= false;
  removeCHAPPAccountType = false;
  noteSaved: boolean= false;
  constructor(
    private route: ActivatedRoute
  ) { } 

  ngOnInit(): void {
    this.subs = this.route.params.subscribe(params => {
      this.userId = params.uid;
    });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }  

  updateUserData(event: IExternalUser): void {
    this.userData = event;
  }

  onChangeAccountType(event: string): void {
    if (event) {
      this.accountTypeNew = event;
    }
  }

  onUserAccountInformationChanged(): void {
     this.userAccountInformationChanged ++;
  }
  ondiableradionbtns(event:boolean){
    this.disableRadioButtons = event;
  }
  onremoveCHAPPAccountType(event: boolean){
    this.removeCHAPPAccountType = event;
  }
  isNoteSaved(value: any){
    this.noteSaved = value.detail;
  }
}
